module.exports = __webpack_public_path__ + "img/Open Bail.8151d05d.png";